import { type FC, useEffect, useState } from 'react'
import { useTranslation } from '@egw/i18n'
import { Dialog, Button, Logo } from '@egw/components'
import { notifications, NOTIFICATIONS } from '@egw/notifications'

export const RefreshPage: FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation('features-system')

  useEffect(() => {
    const handleNotification = (): void => {
      setIsOpen(true)
    }
    notifications.on(NOTIFICATIONS.RISK_SERVICE.NO_DEVICE_ID, handleNotification)
  }, [])

  const refreshPage = (): void => {
    window.location.reload()
  }

  return (
    <Dialog isOpen={isOpen} hideTopBar isFullScreen={false}>
      <div className="px-sm py-lg text-center">
        <Logo className="mx-auto mb-lg fill-gray-500" />
        <p className="mb-sm">{t('refresh.title')}</p>
        <p className="mb-xl">{t('refresh.description')}</p>
        <Button variant="secondary" className="mx-auto" onClick={refreshPage}>
          {t('refresh.refresh')}
        </Button>
      </div>
    </Dialog>
  )
}
